module.exports = __webpack_public_path__ + "static/NeutraText-Book-e999ba4e0118aa852ce49e0a44857340.ttf";